import {
  Component,
  Inject,
  OnInit,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Pos } from '../core/classes/pos';
import { ApiEndpointsService } from '../core/services/api-endpoints.service';
import { IHttpService } from '../core/services/ihttp.service';
import { Observable } from 'rxjs';
import { Product } from '../core/classes/product';
import { ProductService } from '../core/services/product.services';
import { switchMap } from 'rxjs/operators';

import {
  NgbdSortableHeader,
  SortEvent,
} from 'src/app/directives/sortable/sortable.directive';
import { Brand } from '../core/classes/brand';
import { Subbrand } from '../core/classes/subbrand';
import { Line } from '../core/classes/line';
import { Format } from '../core/classes/format';
import { ProductFilter } from '../core/classes/productFilter';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  ValidationErrors,
} from '@angular/forms';
import { ThrowStmt, ProviderAstType } from '@angular/compiler';
import { PreferredCallTime } from '../core/classes/preferredCallTime';
import { PosType } from '../core/classes/posType';
import { DataService } from '../core/services/data.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'dq-detail-pos',
  templateUrl: './detail-pos.component.html',
  styleUrls: ['./detail-pos.component.scss'],
})
export class DetailPosComponent implements OnInit {
  posSelected: Pos;
  returnData: any;
  editMode: boolean = false;

  products$!: Observable<Product[]>;
  brand$!: Observable<Brand[]>;
  subbrand$!: Observable<Subbrand[]>;
  line$!: Observable<Line[]>;
  format$!: Observable<Format[]>;

  preferredsCallTime: PreferredCallTime[] = [];
  posTypes: PosType[] = [];

  @ViewChildren(NgbdSortableHeader) headers:
    | QueryList<NgbdSortableHeader>
    | undefined;

  public nestedForm: FormGroup;
  public showEditActionButton: boolean;

  constructor(
    private route: ActivatedRoute,
    @Inject('HttpService') private httpService: IHttpService,
    private apiEndpointsService: ApiEndpointsService,
    private productService: ProductService,
    public formBuilder: FormBuilder,
    private dataService: DataService
  ) {
    this.route = route;
    this.posSelected = new Pos(0, '', '');
    this.nestedForm = this.createForm();
    this.preferredsCallTime = [];
    this.showEditActionButton = !this.dataService.getIsSuperViewer();
  }

  loadPosData(posId: any) {
    this.httpService
      .get(this.apiEndpointsService.getPosDetailEndpoint(posId))
      .subscribe((data) => {
        if (
          data != undefined &&
          data.value != undefined &&
          data.value[0] != undefined
        ) {
          let entry = data.value[0];
          let p = new Pos(entry.POS, entry.COMERCIALNAME, entry.FISCALNAME);
          p.address = entry.FULLADDRESS;
          p.lat = entry.SHIPPINGLATITUDE;
          p.lon = entry.SHIPPINGLONGITUDE;
          p.openIndicator = entry.OPENINGHOURSINDICATOR;
          p.customer = entry.CUSTOMER;
          p.typePosDescription = entry.DESCRIPTION;
          p.typePosSapCode = entry.SAPCODE;
          p.tam = entry.TAM;
          p.nameTam = entry.NAMETAM;
          p.idRDC = entry.IRRDC;
          p.nameRDC = entry.NAMERDC;
          p.internalSales = entry.INTERNALSALES;
          p.morningOpeningTime = entry.MORNINGOPENINGTIME;
          p.morningClosingTime = entry.MORNINGCLOSINGTIME;
          p.afternoonOpeningTime = entry.AFTERNOONOPENINGTIME;
          p.afternoonClosingTime = entry.AFTERNOONCLOSINGTIME;
          p.openingAdditionalInfo = entry.OPENINGADDITIONALINFO;
          p.preferredTimeCall = entry.PREFERREDTIMECALL;
          p.phone1 = entry.PHONE1;
          p.phone1Print = entry.PHONE1_PRINT;
          p.phone2 = entry.PHONE2;
          p.phone2Print = entry.PHONE2_PRINT;
          p.phone3 = entry.PHONE3;
          p.phone3Print = entry.PHONE3_PRINT;
          p.email1 = entry.EMAIL1;
          p.email1Print = entry.EMAIL1_PRINT;
          p.email2 = entry.EMAIL2;
          p.email2Print = entry.EMAIL2_PRINT;
          p.email3 = entry.EMAIL3;
          p.email3Print = entry.EMAIL3_PRINT;
          p.website = entry.WEBSITE;
          p.shippingCity = entry.SHIPPINGCITY;
          p.shippingCountry = entry.SHIPPINGCOUNTRY;
          p.shippingPostalCode = entry.SHIPPINGPOSTALCODE;
          p.shippingState = entry.SHIPPINGSTATE;
          p.shippingStreet = entry.SHIPPINGSTREET;
          p.origin =
            entry.STOREKEY != null && entry.STOREKEY != '' ? 'IND' : '';
          p.storeKey = entry.STOREKEY;
          p.status = entry.STATUS;
          p.notVisible = entry.NO_VISIBLE;
          p.idsfAccount = entry.IDSFACCOUNT;

          this.posSelected = p;

          this.dataToForm();
        }
        this.returnData = data;
      });
  }

  ngOnInit(): void {
    this.preferredsCallTime = [];
    this.nestedForm = this.createForm();
    this.route.params.subscribe((params) => {
      this.loadPosData(params.id);

      this.httpService
        .get(this.apiEndpointsService.getPreferredTimeCall())
        .subscribe((data) => {
          if (
            data != undefined &&
            data.value != undefined &&
            data.value[0] != undefined
          ) {
            for (let i = 0; i < data.value.length; i++) {
              let entry = data.value[i];
              let p: PreferredCallTime;
              if (entry.PREFERREDTIMECALL != 'null') {
                p = new PreferredCallTime(
                  entry.PREFERREDTIMECALL,
                  entry.PREFERREDTIMECALL
                );
              } else {
                p = new PreferredCallTime('', '');
              }

              this.preferredsCallTime.push(p);
            }
          }
        });
      this.httpService
        .get(this.apiEndpointsService.getPosType())
        .subscribe((data) => {
          if (
            data != undefined &&
            data.value != undefined &&
            data.value[0] != undefined
          ) {
            for (let i = 0; i < data.value.length; i++) {
              let entry = data.value[i];
              let p: PosType;
              if (entry.SAPCODE != 'null') {
                p = new PosType(entry.SAPCODE, entry.DESCRIPTION);
              } else {
                p = new PosType('', '');
              }
              this.posTypes.push(p);
            }
          }
        });
    });

    this.products$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.productService.iniProducts(params.get('id'))
      )
    );

    this.brand$ = this.productService.getBrand();
    this.subbrand$ = this.productService.getSubrand();
    this.line$ = this.productService.getLine();
    this.format$ = this.productService.getFormat();
  }

  createForm(): FormGroup {
    return this.formBuilder.group({
      generalDataForm: this.createFormGeneralData(),
      locationForm: this.createFormLocation(),
    });
  }

  get generalDataForm(): FormGroup {
    return this.nestedForm?.get('generalDataForm') as FormGroup;
  }

  get locationForm(): FormGroup {
    return this.nestedForm?.get('locationForm') as FormGroup;
  }

  createFormLocation(): FormGroup {
    return this.formBuilder.group({
      city: [
        '',
        {
          validators: [Validators.required, Validators.maxLength(50)],
        },
      ],
      street: [
        '',
        {
          validators: [Validators.required, Validators.maxLength(100)],
        },
      ],
      postalCode: [
        '',
        {
          validators: [Validators.required, Validators.maxLength(50)],
        },
      ],
      country: [
        '',
        {
          validators: [Validators.required, Validators.maxLength(50)],
        },
      ],
      state: [
        '',
        {
          validators: [Validators.maxLength(50)],
        },
      ],
      lat: [
        '',
        {
          validators: [Validators.required],
        },
      ],
      lon: [
        '',
        {
          validators: [Validators.required],
        },
      ],
    });
  }
  createFormGeneralData(): FormGroup {
    return this.formBuilder.group({
      commercialName: [
        '',
        {
          validators: [Validators.required],
          updateOn: 'blur',
        },
      ],
      typePos: [
        '',
        {
          validators: [],
        },
      ],
      morningOpeningTime: [
        '',
        {
          validators: [
            Validators.pattern(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/),
          ],
        },
      ],
      morningClosingTime: [
        '',
        {
          validators: [
            Validators.pattern(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/),
          ],
        },
      ],
      afternoonOpeningTime: [
        '',
        {
          validators: [
            Validators.pattern(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/),
          ],
        },
      ],
      afternoonClosingTime: [
        '',
        {
          validators: [
            Validators.pattern(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/),
          ],
        },
      ],
      openingAdditionalInfo: [
        '',
        {
          validators: [],
        },
      ],
      preferredTimeCall: [
        '',
        {
          validators: [],
        },
      ],
      phone1: [
        '',
        {
          validators: [Validators.pattern(/^([+]?[0-9]{9,11})$/)],
        },
      ],
      phone1Print: [
        '',
        {
          validators: [],
        },
      ],
      phone2: [
        '',
        {
          validators: [Validators.pattern(/^([+]?[0-9]{9,11})$/)],
        },
      ],
      phone2Print: [
        '',
        {
          validators: [],
        },
      ],
      phone3: [
        '',
        {
          validators: [Validators.pattern(/^([+]?[0-9]{9,11})$/)],
        },
      ],
      phone3Print: [
        '',
        {
          validators: [],
        },
      ],
      email1: [
        '',
        {
          validators: [],
        },
      ],
      email1Print: [
        '',
        {
          validators: [],
        },
      ],
      email2: [
        '',
        {
          validators: [],
        },
      ],
      email2Print: [
        '',
        {
          validators: [],
        },
      ],
      email3: [
        '',
        {
          validators: [],
        },
      ],
      email3Print: [
        '',
        {
          validators: [],
        },
      ],
      notVisible: [
        '',
        {
          validators: [],
        },
      ],
      status: [
        '',
        {
          validators: [Validators.required],
        },
      ],
    });
  }
  private dataToForm() {
    //console.log('dataToForm');
    if (this.posSelected != null && this.nestedForm != null) {
      this.nestedForm
        .get('generalDataForm')
        ?.get('commercialName')
        ?.setValue(this.posSelected.commercialName);
      this.nestedForm
        .get('generalDataForm')
        ?.get('typePos')
        ?.setValue(this.posSelected.typePosSapCode);
      this.nestedForm
        .get('generalDataForm')
        ?.get('morningOpeningTime')
        ?.setValue(this.posSelected.morningOpeningTime);
      this.nestedForm
        .get('generalDataForm')
        ?.get('morningClosingTime')
        ?.setValue(this.posSelected.morningClosingTime);
      this.nestedForm
        .get('generalDataForm')
        ?.get('afternoonOpeningTime')
        ?.setValue(this.posSelected.afternoonOpeningTime);
      this.nestedForm
        .get('generalDataForm')
        ?.get('afternoonClosingTime')
        ?.setValue(this.posSelected.afternoonClosingTime);
      this.nestedForm
        .get('generalDataForm')
        ?.get('openingAdditionalInfo')
        ?.setValue(this.posSelected.openingAdditionalInfo);
      /*  this.nestedForm
        .get('generalDataForm')
        ?.get('preferredTimeCall')
        ?.setValue(this.posSelected.preferredTimeCall); */
      this.nestedForm
        .get('generalDataForm')
        ?.get('phone1')
        ?.setValue(this.posSelected.phone1);
      this.nestedForm
        .get('generalDataForm')
        ?.get('phone1Print')
        ?.setValue(this.posSelected.phone1Print);
      this.nestedForm
        .get('generalDataForm')
        ?.get('phone2')
        ?.setValue(this.posSelected.phone2);
      this.nestedForm
        .get('generalDataForm')
        ?.get('phone2rint')
        ?.setValue(this.posSelected.phone2Print);
      this.nestedForm
        .get('generalDataForm')
        ?.get('phone3')
        ?.setValue(this.posSelected.phone3);
      this.nestedForm
        .get('generalDataForm')
        ?.get('phone3Print')
        ?.setValue(this.posSelected.phone3Print);
      this.nestedForm
        .get('generalDataForm')
        ?.get('email1')
        ?.setValue(this.posSelected.email1);
      this.nestedForm
        .get('generalDataForm')
        ?.get('email1Print')
        ?.setValue(this.posSelected.email1Print);
      this.nestedForm
        .get('generalDataForm')
        ?.get('email2')
        ?.setValue(this.posSelected.email2);
      this.nestedForm
        .get('generalDataForm')
        ?.get('email2Print')
        ?.setValue(this.posSelected.email2Print);
      this.nestedForm
        .get('generalDataForm')
        ?.get('email3')
        ?.setValue(this.posSelected.email3);
      this.nestedForm
        .get('generalDataForm')
        ?.get('email3Print')
        ?.setValue(this.posSelected.email3Print);
      this.nestedForm
        .get('locationForm')
        ?.get('city')
        ?.setValue(this.posSelected.shippingCity);
      this.nestedForm
        .get('locationForm')
        ?.get('country')
        ?.setValue(this.posSelected.shippingCountry);
      this.nestedForm
        .get('locationForm')
        ?.get('state')
        ?.setValue(this.posSelected.shippingState);
      this.nestedForm
        .get('locationForm')
        ?.get('postalCode')
        ?.setValue(this.posSelected.shippingPostalCode);
      this.nestedForm
        .get('locationForm')
        ?.get('street')
        ?.setValue(this.posSelected.shippingStreet);
      this.nestedForm
        .get('locationForm')
        ?.get('lat')
        ?.setValue(this.posSelected.lat);
      this.nestedForm
        .get('locationForm')
        ?.get('lon')
        ?.setValue(this.posSelected.lon);
      this.nestedForm
        .get('generalDataForm')
        ?.get('status')
        ?.setValue(this.posSelected.status);
      this.nestedForm
        .get('generalDataForm')
        ?.get('notVisible')
        ?.setValue(this.posSelected.notVisible);
    }
    ////console.log('Info', this.nestedForm.value);
  }

  getDatosTiendaFormData(): any {
    let retorno = {
      SAPCODE: this.nestedForm.get('generalDataForm')?.get('typePos')?.value,
      DESCRIPTION: this.getTypePosDescription(
        this.nestedForm.get('generalDataForm')?.get('typePos')?.value
      ),
    };
    ////console.log(retorno);
    return retorno;
  }

  getTypePosDescription(sapcode: string): string {
    let posType: PosType = this.posTypes.filter((x) => x.id == sapcode)[0];
    return posType.name;
  }

  getDatosHorariosFormData(): any {
    let retorno = {
      MORNINGOPENINGTIME: this.nestedForm
        .get('generalDataForm')
        ?.get('morningOpeningTime')?.value,
      MORNINGCLOSINGTIME: this.nestedForm
        .get('generalDataForm')
        ?.get('morningClosingTime')?.value,
      AFTERNOONOPENINGTIME: this.nestedForm
        .get('generalDataForm')
        ?.get('afternoonOpeningTime')?.value,
      AFTERNOONCLOSINGTIME: this.nestedForm
        .get('generalDataForm')
        ?.get('afternoonClosingTime')?.value,
      OPENINGADDITIONALINFO: this.nestedForm
        .get('generalDataForm')
        ?.get('openingAdditionalInfo')?.value,
      /*,
         "IDSFACCOUNT": "string",
      "IDSAP": "string",
      "GEOCODE": "string",
      "MORNINGOPENINGTIME": "string",
      "MORNINGCLOSINGTIME": "string",
      "AFTERNOONOPENINGTIME": "string",
      "AFTERNOONCLOSINGTIME": "string",
      "OPENINGADDITIONALINFO": "string",
      "ACCOUNTNUMBER": "string",
      "LASTMODIFIEDDATE": "2017-04-13",
      "LASTMODIFIEDUSER": "string"*/
    };
    //console.log(retorno);
    return retorno;
  }

  onEdit() {
    this.editMode = true;
  }

  onValidate() {
    ////console.log('on validate');
    for (var i in this.nestedForm.controls) {
      this.nestedForm.controls[i].markAsTouched();
    }
  }
  onCancel() {
    this.loadPosData(this.posSelected.id);
    this.editMode = false;
  }

  onSave() {
    for (var i in this.nestedForm.controls) {
      this.nestedForm.controls[i].markAsTouched();
    }

    //console.log('--- form validation: ----');
    //console.log(this.nestedForm);
    //console.log(this.nestedForm.valid);

    if (this.nestedForm.valid) {
      this.httpService
        .get(
          this.apiEndpointsService.getDatosContactoEndPoint(
            this.posSelected.idsfAccount
          )
        )
        .subscribe((data) => {
          var datosContacto = data;
          this.actualizarDatosTiendaContactoHorarios(datosContacto);
        });
    } else {
      this.editMode = false;
    }
  }

  actualizarDatosTiendaContactoHorarios(datosContacto: any) {
    datosContacto = Object.assign(
      {},
      this.removeOdataContext(datosContacto),
      this.getContactFormData(),
      this.getAdditionalInfo()
    );
    datosContacto = this.setAuditInfo(datosContacto);
    this.httpService
      .patch(
        this.apiEndpointsService.getDatosContactoEndPointPatch(
          datosContacto.IDSFACCOUNT
        ),
        datosContacto
      )
      .subscribe((data) => {
        this.actualizarDatosHoararioTienda(datosContacto);
      });
  }

  setAuditInfo(data: any) {
    data.LASTMODIFIEDDATE = formatDate(new Date(), 'YYYY-MM-dd', 'en-US');
    data.LASTMODIFIEDUSER = this.dataService
      .getUserInfo()
      .userName.split('@')[0]
      .slice(0, 19);
    return data;
  }

  getAdditionalInfo(): any {
    return {
      CHECKSTATUS: 'C',
      DQM_CODE: 'C',
      ADDR_INFO_CODE: null,
      GEO_INFO_CODE: null,
    };
  }

  actualizarDatosHoararioTienda(datosContacto: any) {
    this.httpService
      .get(
        this.apiEndpointsService.getHorarioTiendaEndPoint(
          datosContacto.IDSFACCOUNT
        )
      )
      .subscribe((data) => {
        var datosHorario = data;
        datosHorario = Object.assign(
          {},
          this.removeOdataContext(datosHorario),
          this.getDatosHorariosFormData()
        );

        datosHorario = this.setAuditInfo(datosHorario);

        this.httpService
          .patch(
            this.apiEndpointsService.getHorarioTiendaEndPointPatch(
              datosHorario.IDSFACCOUNT
            ),
            datosHorario
          )
          .subscribe((data) => {
            this.actualizarDatosTienda(data);
          });
      });
  }

  actualizarDatosTienda(datosContacto: any) {
    this.httpService
      .get(
        this.apiEndpointsService.getDatosTiendaEndPoint(
          datosContacto.IDSFACCOUNT
        )
      )
      .subscribe((data) => {
        var datosTienda = data;
        datosTienda = Object.assign(
          {},
          this.removeOdataContext(datosTienda),
          this.getDatosTiendaFormData()
        );

        // actualmente datos tienda no tiene campos de control
        //datosTienda = this.setAuditInfo(datosTienda);

        this.httpService
          .patch(
            this.apiEndpointsService.getDatosTiendaEndPointPatch(
              datosTienda.IDSFACCOUNT
            ),
            datosTienda
          )
          .subscribe((data) => {
            this.loadPosData(this.posSelected.id);
            this.editMode = false;
            this.dataService.sendRefreshPosWarningsCount();
          });
        //console.log(datosTienda);
      });
  }

  getContactFormData(): any {
    let retorno = {
      COMERCIALNAME: this.nestedForm
        .get('generalDataForm')
        ?.get('commercialName')?.value,
      EMAIL1: this.nestedForm.get('generalDataForm')?.get('email1')?.value,
      EMAIL1_PRINT: this.nestedForm.get('generalDataForm')?.get('email1Print')
        ?.value
        ? 'X'
        : '',
      EMAIL2: this.nestedForm.get('generalDataForm')?.get('email2')?.value,
      EMAIL2_PRINT: this.nestedForm.get('generalDataForm')?.get('email2Print')
        ?.value
        ? 'X'
        : '',
      EMAIL3: this.nestedForm.get('generalDataForm')?.get('email3')?.value,
      EMAIL3_PRINT: this.nestedForm.get('generalDataForm')?.get('email3Print')
        ?.value
        ? 'X'
        : '',
      PHONE1: this.nestedForm.get('generalDataForm')?.get('phone1')?.value,
      PHONE1_PRINT: this.nestedForm.get('generalDataForm')?.get('phone1Print')
        ?.value
        ? 'X'
        : '',
      PHONE2: this.nestedForm.get('generalDataForm')?.get('phone2')?.value,
      PHONE2_PRINT: this.nestedForm.get('generalDataForm')?.get('phone2Print')
        ?.value
        ? 'X'
        : '',
      PHONE3: this.nestedForm.get('generalDataForm')?.get('phone3')?.value,
      PHONE3_PRINT: this.nestedForm.get('generalDataForm')?.get('phone3Print')
        ?.value
        ? 'X'
        : '',
      SHIPPINGCITY: this.nestedForm.get('locationForm')?.get('city')?.value,
      SHIPPINGCOUNTRY: this.nestedForm.get('locationForm')?.get('country')
        ?.value,
      SHIPPINGPOSTALCODE: this.nestedForm.get('locationForm')?.get('postalCode')
        ?.value,
      SHIPPINGSTREET: this.nestedForm.get('locationForm')?.get('street')?.value,
      SHIPPINGSTATE: this.nestedForm.get('locationForm')?.get('state')?.value,
      SHIPPINGLATITUDE: this.nestedForm.get('locationForm')?.get('lat')?.value,
      SHIPPINGLONGITUDE: this.nestedForm.get('locationForm')?.get('lon')?.value,
      NO_VISIBLE: this.nestedForm.get('generalDataForm')?.get('notVisible')
        ?.value
        ? 'X'
        : '',
      STATUS: this.nestedForm.get('generalDataForm')?.get('status')?.value,
    };
    //console.log(retorno);
    return retorno;
  }

  onSort({ column, direction }: SortEvent) {
    if (this.headers) {
      this.headers.forEach((header) => {
        if (header.sortable !== column) {
          header.direction = '';
        }
      });

      this.productService.sortColumn = column;
      this.productService.sortDirection = direction;
    }
  }

  onFilterChange(data: ProductFilter) {
    this.productService.filterProducts(data);
  }

  removeOdataContext(data: any): any {
    // Object.keys(data).forEach((key) => {
    //  if (data[key] === null || data[key] === undefined) {
    delete data['@odata.context'];

    //  }
    //});
    return data;
  }
}
